import React from 'react';
import PropTypes from 'prop-types';

import AllowedStateEditCard from './AllowedStateEditCard';
import AllowedStateReasonsEditCard from './AllowedStateReasonsEditCard';

const AllowedStateComponent = ({
  stateEdit,
  reasonsEdit,
  documentStateList,
  documentStateReasonsList,
  onStatePropertyChanged,
  onReasonsPropertyChanged,
  onReasonsListChanged,
  validation,
  reasonValidation
}) => {
  return (
    <>
      <AllowedStateEditCard
        allowedState={stateEdit}
        documentStateList={documentStateList}
        onPropertyChanged={onStatePropertyChanged}
        validation={validation}
      />
      <AllowedStateReasonsEditCard
        reasons={reasonsEdit}
        documentStateReasonsList={documentStateReasonsList}
        onPropertyChanged={onReasonsPropertyChanged}
        onListChanged={onReasonsListChanged}
        changed={stateEdit.documentStateReasonsChanged}
        validation={reasonValidation}
      />
    </>
  );
};

AllowedStateComponent.propTypes = {
  stateEdit: PropTypes.object.isRequired,
  reasonsEdit: PropTypes.array.isRequired,
  documentStateList: PropTypes.array.isRequired,
  documentStateReasonsList: PropTypes.array.isRequired,
  onStatePropertyChanged: PropTypes.func.isRequired,
  onReasonsPropertyChanged: PropTypes.func.isRequired,
  onReasonsListChanged: PropTypes.func.isRequired,
  validation: PropTypes.object,
  reasonValidation: PropTypes.object
};

export default AllowedStateComponent;
